





















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class OptionSelector extends Vue {
    @Prop() private items!: { id: number; label: string }[];

    private isShow:boolean = false;

    private mounted():void {
        document.addEventListener('click', this.onClickDocument);
    }

    private destroyed():void {
        document.removeEventListener('click', this.onClickDocument);
    }

    private toggle(e:any): void {
        this.isShow = !this.isShow;
    }

    private close(): void {
        this.isShow = false;
    }

    private onClickDocument(e:any) {
        if (! e.target.parentNode.classList.contains('option-selector')) {
            this.close();
        }
    }

    private onClick(id: number): void {
        this.$emit('change', id)
    }
}
